import { createAction, makeActionTrackable } from '@lingoda/core';

type TourType = 'startTourCourse';

export default makeActionTrackable(createAction<TourType>('student/START_TOUR'));
